import { z } from 'zod';

export const contactFormSchema = z.object({
  phoneCountry: z.string(),
  phoneNumber: z.string().min(1, 'Phone number is required'),
  headOffice: z.string().optional(),
  otherOffices: z.array(z.string()).optional(),
  paidStaffLocations: z.array(z.string()).optional(),
  contactName: z.string().optional(),
  contactEmail: z.string().email().optional().or(z.literal('')),
  contactLinkedIn: z.string().optional(),
  contactBio: z.string().optional()
});

export type ContactFormValues = z.infer<typeof contactFormSchema>;
